module.exports = __webpack_public_path__ + "img/XT-Cortadora.d67cca8a.png";